import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { SidebarHeader } from '~/components/sidebar';
import { SmallerContainer, BiggerContainer } from '~/components/layout/mediaquery';
import { useTheme } from '~/components/theme/theme-context';
import IconButtonClose from '~/components/misc/icon-button-close';
import IconChevronLeft from '~/components/misc/icon-chevron-left-button';
import useWizard from '~/components/authentication/wizard/hooks/use-wizard';
import { ACTIONTYPES } from '~/components/authentication/wizard/utils/constants';
import { isFunction } from '~/components/authentication/utils';

const SidebarHeaderIcon = ({ icon, clickHandler }) => {
	switch (icon) {
		case ACTIONTYPES.close:
			return (
				<IconButtonClose
					onClick={clickHandler}
					className="page-head__close automation-test-registration-basic-exit-link"
					dataAt="close-register-step1-registerationpage"
				/>
			);
		case ACTIONTYPES.back:
			return (
				<IconChevronLeft
					onClick={clickHandler}
					className="page-head__close automation-test-registration-basic-exit-link"
					data-at="close-register-step1-registerationpage"
				/>
			);
		case ACTIONTYPES.none:
		default:
			return null;
	}
};

const WizardSidebarHeader = ({ titleKey, actionHandler, moreActionHandler, iconOverrides = {}, config = null }) => {
	const screenMedium = useSelector(state => state.browser.lessThan.medium);
	const { Logo } = useTheme();
	const { step, translations, exit, previous, next, subStep } = useWizard();

	const headerConfig = config ?? subStep?.header ?? step.header ?? {};
	const title = translations[titleKey ?? headerConfig.text];
	const moreActionTitle = translations[headerConfig.moreAction?.text];

	const clickHandler = useCallback(
		type => {
			if (isFunction(actionHandler)) {
				actionHandler();
			}

			if (type === ACTIONTYPES.close) {
				exit();
			} else if (type === ACTIONTYPES.back) {
				previous();
			}
		},
		[actionHandler, exit, previous]
	);

	const secondaryClickHandler = useCallback(
		type => {
			if (isFunction(moreActionHandler)) {
				moreActionHandler();
			} else if (type === ACTIONTYPES.skip) {
				next();
			}
		},
		[moreActionHandler, next]
	);

	const headerIconProps = {
		icon: headerConfig.action,
		clickHandler: () => clickHandler(headerConfig.action),
		...iconOverrides
	};

	return (
		<SidebarHeader
			sticky={false}
			stickySmaller
			transparent={!screenMedium}
			Icon={<SidebarHeaderIcon {...headerIconProps} />}
		>
			<BiggerContainer>
				{title && (
					<h1 className="page-head__title" data-at="logo-header-register-step1-registerationpage">
						{title}
					</h1>
				)}
			</BiggerContainer>
			<SmallerContainer>
				<div className="page-head__title" data-at="logo-header-register-step1-registerationpage">
					<Logo />
				</div>
			</SmallerContainer>
			<div className="page-head__right-side">
				{headerConfig.moreAction && (
					<button
						className="btn btn--skip"
						data-at="skip-bonus-step1-registerationpage"
						onClick={() => secondaryClickHandler(headerConfig.moreAction?.type)}
					>
						{moreActionTitle}
					</button>
				)}
			</div>
		</SidebarHeader>
	);
};

export default WizardSidebarHeader;
